import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getResetRequestFromEmailPath = (userId: string = ':userId', token: string = ':token') =>
  urlHelper(`/users/${userId}/reset-request/${token}/`);
